module.exports = __webpack_public_path__ + "img/保护工作站.53af8bda.png";